"use client";

import { Currencies } from "@/types/types";
import React, { createContext, useContext } from "react";

export interface CurrenciesContextType {
  currenciesRates: Currencies;
}

const CurrenciesContext: React.Context<CurrenciesContextType | null> =
  createContext<CurrenciesContextType | null>(null);

export function CurrenciesContextWrapper({
  children,
  initialState,
}: {
  children: React.ReactNode;
  initialState: Currencies;
}) {
  return (
    <CurrenciesContext.Provider
      value={{
        currenciesRates: initialState,
      }}
    >
      {children}
    </CurrenciesContext.Provider>
  );
}

export function useCurrenciesContext() {
  const context = useContext(CurrenciesContext);
  if (!context) {
    throw new Error("Unable to use context for user auth data");
  }
  return context;
}
